export default __webpack_public_path__ + "static/media/113.af4c4e0f.jpg";